<template>
  <div 
    class="service-card" 
    :class="{ 'service-card-selected': selected }"
    @click="$emit('select', service)"
  >
     <div v-if="selected" class="selected-checkmark">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#14532d"/>
        <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h3 class="service-card-title">{{ service.title }}</h3>
    <div class="service-price">{{ service.price }}</div>
    <div class="service-features">
      <span 
        v-for="(feature, index) in service.features" 
        :key="index" 
        class="feature-item"
      >
        <span class="feature-bullet"> • </span><span class="feature-text">{{ feature }}</span>
      </span>
    </div> 
    <button 
      v-if="!selected && !showUpgrade" 
      class="service-select-btn"
      @click.stop="$emit('select', service)"
    >
      Select
    </button>
    <button 
      v-if="showUpgrade" 
      class="service-upgrade-btn"
      @click.stop="$emit('select', service)"
    >
      Upgrade to Executive
    </button>
  </div>
</template>

<script>
export default {
  name: 'ServiceCard',
  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        title: '',
        price: '',
        features: []
      })
    },
    selected: {
      type: Boolean,
      default: false
    },
    showUpgrade: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select']
};
</script>

<style scoped>
.service-card {
  position: relative;
  width: 316px;
  height: 165px;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background: #F4F6FA;
  transition: all 0.2s ease;
  cursor: pointer;
  opacity: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
}

.service-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.service-card-selected {
  border: 2px solid #79E864;
  background: linear-gradient(180deg, #79E864 0%, #FFFFFF 100%); 
}

.service-card:not(.service-card-selected) {
  background: #F4F6FA;
  border: none;
}

.selected-checkmark {
  position: absolute;
  top: 12px;
  right: 12px;
}

.service-card-title {
  font-family: Poppins;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #111827;
  margin: 0 0 12px 0;
}

.service-price {
  font-family: Poppins;
  font-weight: 600;
  font-style: normal;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #111827;
  margin-bottom: 16px;
}

.service-features {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 20px;
  align-items: center;
}

.feature-item {
  font-size: 13px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}

.feature-bullet {
  color: #79E864;
  margin-right: 4px;
}

.feature-text {
  color: #111827;
}

.service-select-btn {
  width: 292px;
  height: 37px;
  padding: 10px 28px;
  background: #79E864;
  border: 1px solid #79E864;
  border-radius: 10px;
  color: #000000;
  font-family: Poppins;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-select-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.service-upgrade-btn {
  width: 292px;
  height: 37px;
  padding: 10px 28px;
  background: #79E864;
  border: 1px solid #79E864;
  border-radius: 10px;
  color: #000000;
  font-family: Poppins;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-upgrade-btn:hover {
  background: #6dd84f;
  border-color: #6dd84f;
  box-shadow: 0 2px 6px rgba(121, 232, 100, 0.3);
}

/* Responsive Styles */
@media (max-width: 768px) {
  .service-card {
    width: 100%;
    max-width: 316px;
    min-height: 155px;
    height: auto;
  }

  .service-select-btn,
  .service-upgrade-btn {
    width: 100%;
    max-width: 292px;
  }
}

@media (max-width: 576px) {
  .service-card {
    width: 100%;
    max-width: 100%;
    min-height: 155px;
    height: auto;
  }

  .service-select-btn,
  .service-upgrade-btn {
    width: 100%;
    max-width: 292px;
  }
}
</style>
